import Doi from './Doi';

export default Doi;
